import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import { CiSearch } from "react-icons/ci";
import Button from "react-bootstrap/Button";
import { RxCross2 } from "react-icons/rx";
import { Card } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
// import "../Companies/searchContact.css";
import { companiesManagementSelector } from "../Companies/redux/selector";
import Key from "../../clientVariables.json";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function SimplePopper(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops
  const [anchorEl, setAnchorEl] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const popperRef = useRef(null);
  const { searchInput, searchType } = useSelector(companiesManagementSelector);

  const handleClick = (event) => {
    setAnchorEl(!anchorEl);
    props.hideContacts(true);
  };
  const handleClose = () => {
    setAnchorEl(false);
    setSearchQuery("");
    props.handleSearchContacts("", []);
    props.hideContacts(false);
  };
  // useEffect(() => {
  //   if (searchType === 'contact') {
  //     handleSearchContact(searchInput);
  //   }
  // }, [searchInput]);

  useEffect(() => {
    setSearchQuery(props?.searchInputValue);

    const handleClickOutside = (event) => {
      if (popperRef.current && !popperRef.current.contains(event.target)) {
        setAnchorEl(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      // setSearchQuery('')
    };
  }, []);
  useEffect(() => {
    setSearchQuery("");
  }, [props.jobDetails]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;
  const handleSearchContact = (value) => {
    setSearchQuery(value);

    if (value.length > 1) {
      axios
        .post(`${Key.domain_crm}/company/search_contact`, {
          contactName: value,
          companyID: props.companyId || "",
        })
        .then((res) => {
          if (res.data.success === 1) {
            props.handleSearchContacts(value, res.data.data);
          }
        })
        .catch((error) => console.log(error));
    } else {
      // 👇 When input is cleared, reset to default company contacts
      props.handleSearchContacts("", []);
      if (props.companyId) {
        // refetch default company contacts
        axios
          .post(`${Key.domain_crm}/company/get_Company_Contacts`, {
            company_id: props.companyId,
            page: 0,
          })
          .then((res) => {
            if (res.data?.data?.companyContacts?.length > 0) {
              props.handleSearchContacts("", res.data.data.companyContacts);
            }
          })
          .catch((err) => console.log(err));
      }
    }
  };
  
  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        // color="primary"
        onClick={handleClick}
        style={{ display: anchorEl ? "none" : "" }}
      >
        <CiSearch
        // style={{display:anchorEl !=='' && anchorEl !==null ?'none':''}}
        />
      </Button>
      {/* <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start" // Adjust placement as needed
        style={{ zIndex: 9999 }} // Ensure the arrow shows on top of other content
        ref={popperRef}
      >
        {({ TransitionProps }) => ( */}
      {anchorEl ? (
        <div
          style={{
            position: "relative",
            width: "255px",
            // left:"-47px",
            // top:"-41px"
          }}
          className="searchcontact"
        >
          <div
            style={{
              position: "absolute",
              top: "-10px", // Adjust the top position of the arrow
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderTop: "10px solid transparent",
              borderBottom: "10px solid #FFF", // Arrow color
              borderLeft: "10px solid transparent",
            }}
          />
          <Box className="searchBar">
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
              }}
            >
              <input
                type="text"
                placeholder="Search Contact"
                style={{
                  borderRadius: "5px",
                  border: "1px solid lightgrey",
                  padding: "5px",
                  outline: "none",
                }}
                value={searchQuery}
                onChange={(e) => handleSearchContact(e.target.value)}
              />
              &nbsp;
              {/* <IoIosClose size={30}/> */}
              <Button
                style={{ padding: "4px 8px" }} // Adjust the font size here
                onClick={handleClose}
              >
                <RxCross2 />
              </Button>
            </div>
          </Box>
        </div>
      ) : (
        ""
      )}
      {/* )}
      </Popper> */}
    </div>
  );
}
